// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as Rxjs from "../../Rxjs.bs.jsx";
import * as Rxjs$1 from "rxjs";
import * as React from "react";
import * as Header from "../../components/Header/Header.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as EditUser from "./EditUser.bs.jsx";
import * as LogUtils from "../../utils/LogUtils.bs.jsx";
import * as PlaceAdd from "./PlaceAdd.bs.jsx";
import * as Redirect from "../../components/Redirect/Redirect.bs.jsx";
import * as Reactfire from "reactfire";
import * as ReactIntl from "react-intl";
import * as RouterUtils from "../../utils/RouterUtils.bs.jsx";
import * as Stdlib_Null from "@rescript/runtime/lib/es6/Stdlib_Null.js";
import * as Auth from "rxfire/auth";
import * as Auth$1 from "firebase/auth";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as SectionWithHeader from "../../components/SectionWithHeader/SectionWithHeader.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.jsx";
import MyPlacesModuleCss from "./MyPlaces.module.css";

let classes = MyPlacesModuleCss;

let gitShortSha = import.meta.env.VITE_GIT_SHORT_SHA;

function MyPlaces$Pure(props) {
  let usersPlaces = props.usersPlaces;
  let onSignOut = props.onSignOut;
  let onPlaceAdd = props.onPlaceAdd;
  let currentUser = props.currentUser;
  let userDisplayName = Stdlib_Null.getOrThrow(currentUser.displayName);
  let sinceDate = new Date(currentUser.metadata.creationTime);
  return <div
    className={Styles.page.narrow}
  >
    <Header.make
      buttonLeftSlot={<button
        className={Header.classes.buttonLeft}
        type={"button"}
        onClick={param => onSignOut()}
      >
        <span>
          {"🚴‍♂️"}
        </span>
        <span>
          {"Odhlásit"}
        </span>
      </button>}
      buttonRightSlot={<button
        className={Header.classes.buttonRight}
        type={"button"}
        onClick={props.onSettingsClick}
      >
        <span>
          {"⚙️"}
        </span>
        <span>
          {"Nastavení"}
        </span>
      </button>}
      headingSlot={userDisplayName}
      subheadingSlot={<ReactIntl.FormattedMessage
        id={"Place.established"}
        defaultMessage={"Již od {time}"}
        values={{
          time: <time
            key={"time"} 
            dateTime={sinceDate.toISOString()}
          >
            <ReactIntl.FormattedDate
              value={sinceDate}
            />
          </time>
        }}
      />}
    />
    <main>
      <SectionWithHeader.make
        buttonsSlot={<button
          className={Styles.button.base}
          type={"button"}
          onClick={param => onPlaceAdd()}
        >
          {"Nové místo"}
        </button>}
        headerId={"my_places"}
        headerSlot={"Moje místa"}
        noBackground={true}
      >
        {usersPlaces.length !== 0 ? <nav>
            <ul
              className={classes.list}
            >
              {usersPlaces.map(place => {
                let stringId = Db.getUid(place);
                let newrecord = {...RouterUtils.createAnchorProps(undefined, `./` + stringId)};
                return <li
                  key={stringId} >
                  <a
                    {...newrecord} 
                    className={Styles.utility.breakout}
                  >
                    {place.name}
                  </a>
                  <span>
                    {"Založeno: "}
                    <ReactIntl.FormattedDate
                      value={place.createdAt.toDate()}
                      year={"numeric"}
                      month={"numeric"}
                      day={"numeric"}
                    />
                  </span>
                </li>;
              })}
            </ul>
          </nav> : <p
            className={SectionWithHeader.classes.emptyMessage}
          >
            {"Seznam vašich míst je prázdný, nechte se někam pozvat 🍻 nebo "}
            <button
              className={Styles.link.base}
              type={"button"}
              onClick={param => onPlaceAdd()}
            >
              {"založte nové místo pro vaše přátele."}
            </button>
          </p>}
      </SectionWithHeader.make>
    </main>
  </div>;
}

let Pure = {
  make: MyPlaces$Pure
};

function pageDataRx(auth, firestore) {
  let currentUserRx = Rxjs.op(Auth.user(auth), Rxjs.keepMap(prim => {
    if (prim === null) {
      return;
    } else {
      return Primitive_option.some(prim);
    }
  }));
  let userPlacesRx = Rxjs.op(currentUserRx, Rxjs$1.switchMap(user => Db.placesByUserIdRx(firestore, user.uid)));
  return Rxjs$1.combineLatest(currentUserRx, userPlacesRx);
}

function MyPlaces(props) {
  LogUtils.usePageView("MyPlaces");
  let firestore = Reactfire.useFirestore();
  let auth = Reactfire.useAuth();
  let pageDataStatus = Reactfire.useObservable("Page_MyPlaces", pageDataRx(auth, firestore));
  let match = React.useState(() => "Hidden");
  let setDialogState = match[1];
  let hideDialog = param => setDialogState(param => "Hidden");
  let fromHomepage = RouterUtils.isFromHomepage(RescriptReactRouter.useUrl(undefined, undefined));
  let match$1 = pageDataStatus.data;
  let tmp;
  let exit = 0;
  if (fromHomepage) {
    if (match$1 !== undefined) {
      let match$2 = match$1[1];
      if (match$2.length !== 1) {
        exit = 1;
      } else {
        let onePlaceOnly = match$2[0];
        let singlePlaceLocation = RouterUtils.resolveRelativePath(`./` + Db.getUid(onePlaceOnly));
        tmp = <Redirect.make
          to={singlePlaceLocation}
        />;
      }
    } else {
      tmp = null;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    if (match$1 !== undefined) {
      let currentUser = match$1[0];
      let userDisplayName = Stdlib_Null.getOrThrow(currentUser.displayName);
      let tmp$1;
      switch (match[0]) {
        case "Hidden" :
          tmp$1 = null;
          break;
        case "AddPlace" :
          tmp$1 = <PlaceAdd.make
            initialPersonName={userDisplayName}
            onDismiss={hideDialog}
            onSubmit={async param => {
              let placeRef = await Db.Place.add(firestore, param.personName, param.placeName, currentUser.uid);
              return RescriptReactRouter.push(RouterUtils.resolveRelativePath(`./` + placeRef.id));
            }}
          />;
          break;
        case "EditUser" :
          tmp$1 = <EditUser.make
            connectedEmail={Stdlib_Null.getOrThrow(currentUser.email)}
            initialName={userDisplayName}
            onDismiss={hideDialog}
            onSubmit={async values => {
              await Auth$1.updateProfile(currentUser, {
                displayName: values.name
              });
              return setDialogState(param => "Hidden");
            }}
            onChangePassword={async values => {
              let credential = Auth$1.EmailAuthProvider.credential(Stdlib_Null.getOrThrow(currentUser.email), values.oldPassword);
              await Auth$1.reauthenticateWithCredential(currentUser, credential);
              await Auth$1.updatePassword(currentUser, values.newPassword);
            }}
          />;
          break;
      }
      tmp = <>
        <Pure.make
          currentUser={currentUser}
          onPlaceAdd={() => setDialogState(param => "AddPlace")}
          onSignOut={() => {
            RescriptReactRouter.push("/");
            Auth$1.signOut(auth);
            setTimeout(() => {
              window.location.reload();
            }, 0);
          }}
          onSettingsClick={param => setDialogState(param => "EditUser")}
          usersPlaces={match$1[1]}
        />
        {tmp$1}
      </>;
    } else {
      tmp = null;
    }
  }
  return <>
    {tmp}
    <footer
      className={classes.footer}
    >
      {"v.\xA0" + gitShortSha}
    </footer>
  </>;
}

let make = MyPlaces;

export {
  classes,
  gitShortSha,
  Pure,
  pageDataRx,
  make,
}
/* classes Not a pure module */
